import React from 'react';
import { FeedbackTemplate } from '@bb/domain/dist/types/Feedback';
import styled from 'styled-components';

type QuestionSortableProps = {
  question: FeedbackTemplate;
  remove: (index: number) => void;
  index: number;
  edit: (index: number, question: FeedbackTemplate) => void;
  isPreview: boolean;
  notEditable?: boolean;
  ModalService: {
    openQuestionEditModal: (
      question: FeedbackTemplate,
    ) => Promise<FeedbackTemplate>;
  };
};

const QuestionSortable: React.FC<QuestionSortableProps> = ({
  question,
  remove,
  index,
  edit,
  isPreview,
  notEditable,
  ModalService,
}) => {
  const editQuestion = async (existingQuestion: todo) => {
    const updatedQuestion =
      await ModalService.openQuestionEditModal(existingQuestion);
    if (updatedQuestion) edit(index, updatedQuestion);
  };

  return (
    <StyledQuestionSortable $isPreview={!!isPreview}>
      <span onClick={() => remove(index)}>
        <i className="fa fa-times-circle pull-right text-danger icon"></i>
      </span>
      <span onClick={() => editQuestion(question)}>
        <i className="fa fa-pencil-square-o pull-right text-info icon"></i>
      </span>
      <small className="pull-right type">Question type: {question.type}</small>

      {question.type === 'text' && (
        <div>
          <h5 className="control-label">{question.label}</h5>
          <textarea disabled={notEditable} className="form-control"></textarea>
        </div>
      )}

      {question.type === 'select' && (
        <div>
          <h5 className="control-label">{question.label}</h5>
          <select disabled={notEditable} className="form-control">
            {question.options.map((option, i) => (
              <option key={i}>{option}</option>
            ))}
          </select>
        </div>
      )}

      {question.type === 'radio' && (
        <div>
          <h5 className="control-label">{question.label}</h5>
          {question.options.map((option, i) => (
            <div key={i}>
              <StyledAlignContainer className="control-label">
                <input
                  disabled={notEditable}
                  type="radio"
                  name={question.label}
                  value={option}
                />
                <span>{option}</span>
              </StyledAlignContainer>
            </div>
          ))}
        </div>
      )}

      {question.type === 'checkbox' && (
        <div>
          <h5 className="control-label">{question.label}</h5>
          {question.options.map((option, i) => (
            <div key={i}>
              <StyledAlignContainer className="control-label">
                <input
                  disabled={notEditable}
                  type="checkbox"
                  name={option}
                  value={option}
                />
                <span>{option}</span>
              </StyledAlignContainer>
            </div>
          ))}
        </div>
      )}
    </StyledQuestionSortable>
  );
};

export default QuestionSortable;

const StyledAlignContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  input {
    margin: 0 !important;
  }
`;

const StyledQuestionSortable = styled.div<{
  $isPreview: boolean;
}>`
  margin: 0.5em;
  padding: 0.5em 1em 1em 1em;
  border-radius: 0.5em;
  background-color: rgb(245, 245, 245);
  transition-property: box-shadow;
  transition-duration: 0.1s;

  h5 {
    margin-bottom: 27px;
  }

  textarea {
    resize: none;
  }

  > span > .icon {
    opacity: 0;
    font-size: 1.25em;
    transition-property: opacity;
    transition-duration: 0.1s;
  }

  ${props =>
    !props.$isPreview &&
    `cursor: grab;
    :hover {
      box-shadow: 0 0 1em lightgrey;
      > span > .icon {
        opacity: 1;
      }
    }
    > span > .icon:hover {
      text-shadow: 0 0 0.1em grey;
    }`}

  ${props =>
    props.$isPreview &&
    `> span > .icon {
      display: none;
    }`}
`;
